import { render, staticRenderFns } from "./userGroupList.vue?vue&type=template&id=6565e14c&scoped=true"
import script from "./userGroupList.vue?vue&type=script&lang=js"
export * from "./userGroupList.vue?vue&type=script&lang=js"
import style0 from "./userGroupList.vue?vue&type=style&index=0&id=6565e14c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6565e14c",
  null
  
)

export default component.exports